import { FC } from 'react';

import { useTheme } from 'hooks/theme';
import { TooltipTypes } from 'modules/globalTooltip';

import { ScTooltipMessage, ScTooltipMessageProps } from './styled';

interface TooltipMessageProps extends ScTooltipMessageProps {
  type: TooltipTypes;
  text: React.ReactNode;
  onClick?: () => void;
  withArrow?: boolean;
}

export const TooltipMessage: FC<TooltipMessageProps> = ({
  type,
  text,
  withArrow,
  onClick,
  ...styleProps
}) => {
  const {
    successIcon: SuccessIcon,
    infoIcon: InfoIcon,
    warningIcon: WarningIcon,
    errorIcon: ErrorIcon,
    images,
  } = useTheme();

  const icon = {
    [TooltipTypes.SUCCESS]: <SuccessIcon />,
    [TooltipTypes.INFO]: <InfoIcon />,
    [TooltipTypes.WARNING]: <WarningIcon />,
    [TooltipTypes.ERROR]: <ErrorIcon />,
  }[type];

  return (
    <ScTooltipMessage
      success={type === TooltipTypes.SUCCESS}
      warning={type === TooltipTypes.WARNING}
      info={type === TooltipTypes.INFO}
      error={type === TooltipTypes.ERROR}
      onClick={onClick}
      clickable={!!onClick}
      {...styleProps}
    >
      {icon}
      {text}
      {withArrow && (
        <div className="arrow">
          <images.arrowRightIcon.component />
        </div>
      )}
    </ScTooltipMessage>
  );
};
